// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IOutcomeCount {
	label: string | undefined;

	count: number;

	$type?: string | undefined;
}
export class OutcomeCount {
	constructor(data?: IOutcomeCount) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	label: string | undefined;

	count: number = 0;

	static $type: string = "CoreApi.Models.ClientEndpoints.OutcomeCount, ";
	$type?: string | undefined = OutcomeCount.$type;
}

